module.exports = __webpack_public_path__ + "static/media/canada.ed3cd4b5.svg";